import React from "react";
import { useTranslation } from "react-i18next";

export const MenuTitle = ({ title }) => {
    const { t } = useTranslation();

    return (
        <div className="navigation-menu-item">
            <span>{title}</span>
            <span className="beta-badge">{t('appStatus.beta')}</span>
        </div>
    );
};
